import { Component, Input, model } from '@angular/core';

@Component({
    selector: 'c-calendar',
    templateUrl: './calendar.component.html',
    styleUrl: './calendar.component.css',
    standalone: false
})
export class CalendarComponent {
  /** Etiqueta del input */
  @Input() etiqueta = 'Inserte etiqueta';
  /** Placeholder del input */
  @Input() placeholder = 'Inserte placeholder';
  /** Opción seleccionada */
  valor = model<any>();

  today = new Date();

  @Input() minDate: Date | undefined;
  @Input() maxDate: Date | undefined;

  /** Muestra o no las animaciones del componente */
  show = false;

  @Input() showClear = false;
  @Input() showIcon = false;
  @Input() showTime = false;

  /** Permite linkear una variable bool, para mostrar los mensajes de error, desaparece si el usuario
   * ingresa el valor */
  @Input() showError = false;
  @Input() mensajeError = '';
  @Input() readonly = false;

  /** Permite linkear una variable bool, para mostrar los mensajes de error, y dejarlo permanente en
   * caso de ser mas estricto, desaparece solo si el usuario cumple las normas del parent */
  @Input() hardError = false;
}
